import { Box, Paper, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { radius } from "src/design/tokens";

export interface StepCardProps {
  step: number;
  title: string;
  /** Muted text shown at the right of the heading row. */
  aside?: ReactNode;
  children: ReactNode;
}

/** One numbered planner step: a 28 px badge beside the step heading, then the step body. */
export const StepCard = ({ step, title, aside, children }: StepCardProps) => {
  const headingId = `planner-step-${step}`;
  return (
    <Paper
      component="section"
      aria-labelledby={headingId}
      sx={{ p: 2.75, borderRadius: `${radius.card}px` }}
      data-testid="step-card"
    >
      <Stack spacing={2}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            component="span"
            aria-hidden="true"
            sx={{
              width: 28,
              height: 28,
              flex: "none",
              borderRadius: "50%",
              bgcolor: "strong",
              color: "onStrong",
              display: "grid",
              placeItems: "center",
              fontSize: 13,
              fontWeight: 800,
            }}
          >
            {step}
          </Box>
          <Typography id={headingId} variant="h4" component="h2" sx={{ m: 0 }}>
            {title}
          </Typography>
          {aside ? (
            <Typography
              component="span"
              sx={{
                ml: "auto !important",
                fontSize: 12,
                color: "text.secondary",
              }}
            >
              {aside}
            </Typography>
          ) : null}
        </Stack>
        {children}
      </Stack>
    </Paper>
  );
};

export default StepCard;
